<div fxFlexFill>
    <app-side-nav-bar>
        <router-outlet></router-outlet>
    </app-side-nav-bar>
  </div>
<app-loader *ngIf="loadingRouteConfig"></app-loader>
